var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Redirect_1;
import React, { Children, Component } from 'react';
import { Event } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { DataContext, RouteContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, bool, element, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { getLostProps, isObject, propagateProps } from '@philips-internal/oswald-ui-utils';
import { FoundationApplicationContext } from '../../context/index.js';
import RedirectAPI from './redirect-api.js';
const RedirectContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.LIST,
        ComponentType.NAVIGATION,
    ],
    name: '',
};
const DataContextConsumer = DataContext.Context.Consumer;
const RouteContextConsumer = RouteContext.Context.Consumer;
let Redirect = Redirect_1 = class Redirect extends Component {
    constructor() {
        super(...arguments);
        this.getEventValue = (event) => {
            const { event: eventName } = this.props;
            const events = {
                [Event.onClick]: event.value,
                [Event.onSelect]: event.value,
                [Event.onSelectItem]: event.item,
            };
            return events[eventName];
        };
        this.onEvent = (dataContext, routeContext, event) => {
            const { route, scrollToTop = Redirect_1.defaultProps.scrollToTop, } = this.props;
            const eventValue = this.getEventValue(event);
            const parameters = {
                ...dataContext,
            };
            if (isObject(eventValue)) {
                Object.assign(parameters, { ...eventValue });
            }
            const completeRoute = routeContext.nestedRoute(route);
            this.context.redirect(completeRoute, parameters, {
                scrollToTop,
            });
        };
    }
    render() {
        const { children, event, uuid } = this.props;
        if (Children.count(children) === 0) {
            return (React.createElement(Container, { acceptedTypes: RedirectContainer.acceptedTypes, className: "u-expand", uuid: uuid }));
        }
        const lostProps = getLostProps(Redirect_1.propTypes, this.props);
        return (React.createElement(DataContextConsumer, null, (dataContext) => (React.createElement(RouteContextConsumer, null, (routeContext) => propagateProps(children, {
            ...lostProps,
            [event]: (event) => this.onEvent(dataContext, routeContext, event),
        })))));
    }
};
Redirect.contextType = FoundationApplicationContext;
Redirect.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    event: oneOf([Event.onClick, Event.onSelect, Event.onSelectItem]),
    route: string,
    scrollToTop: bool,
    uuid: string,
};
Redirect.defaultProps = {
    event: Event.onClick,
    scrollToTop: true,
};
Redirect = Redirect_1 = __decorate([
    AwesomeComponent({ api: RedirectAPI, containers: [RedirectContainer], type: ComponentType.BEHAVIOR })
], Redirect);
export default Redirect;
//# sourceMappingURL=redirect.js.map